// extracted by mini-css-extract-plugin
export default {"amount":"add-to-card_amount__ZK2jw","btn":"add-to-card_btn__6-eGC"};